import { memo } from 'react';

import type { IconProps } from './types';
import BaseIcon from './BaseIcon';

export default memo((props: IconProps) => {
    return (
        <BaseIcon viewBox="0 0 18 18" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 3.83077C5 3.37195 5.24944 3 5.55714 3H17.4429C17.7506 3 18 3.37195 18 3.83077C18 4.28959 17.7506 4.66154 17.4429 4.66154H5.55714C5.24944 4.66154 5 4.28959 5 3.83077ZM5 9C5 8.54118 5.24944 8.16923 5.55714 8.16923H17.4429C17.7506 8.16923 18 8.54118 18 9C18 9.45882 17.7506 9.83077 17.4429 9.83077H5.55714C5.24944 9.83077 5 9.45882 5 9ZM5 14.1692C5 13.7104 5.24944 13.3385 5.55714 13.3385H17.4429C17.7506 13.3385 18 13.7104 18 14.1692C18 14.6281 17.7506 15 17.4429 15H5.55714C5.24944 15 5 14.6281 5 14.1692Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 3.83077C0 3.37195 0.0575634 3 0.128571 3H2.87143C2.94244 3 3 3.37195 3 3.83077C3 4.28959 2.94244 4.66154 2.87143 4.66154H0.128571C0.0575634 4.66154 0 4.28959 0 3.83077ZM0 9C0 8.54118 0.0575634 8.16923 0.128571 8.16923H2.87143C2.94244 8.16923 3 8.54118 3 9C3 9.45882 2.94244 9.83077 2.87143 9.83077H0.128571C0.0575634 9.83077 0 9.45882 0 9ZM0 14.1692C0 13.7104 0.0575634 13.3385 0.128571 13.3385H2.87143C2.94244 13.3385 3 13.7104 3 14.1692C3 14.6281 2.94244 15 2.87143 15H0.128571C0.0575634 15 0 14.6281 0 14.1692Z"
                fill="currentColor"
            />
        </BaseIcon>
    );
});
